import PropTypes from 'prop-types';

const RimacTag = ({ 
  customClasses = '', 
  color = '#FFE379', 
  text = 'Plan Default' }) => {
  return (
    <div className={`rimacTag ${customClasses}`} style={{ backgroundColor: color }}>
      <p className='rimacTag__text'>{text}</p>
    </div>
  );
}

RimacTag.propTypes = {
  customClasses: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
}

export default RimacTag;